const items = [
  "Klinisk hudhelse",
  "Medisinsk faglighet",
  "Helhetlig tilnærming",
  "Personlig behandlingsplan",
  "Varige resultater",
  "Oslo",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div className="border-y border-[#E5E0DA] bg-[#F7F6F3] overflow-hidden" data-testid="marquee">
      <div className="flex marquee whitespace-nowrap py-6 md:py-7">
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-12 mx-6 shrink-0">
            <span className="font-serif text-2xl md:text-3xl text-[#2C2C2A] italic font-light">{t}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#C4A981]"></span>
          </div>
        ))}
      </div>
    </div>
  );
};
